import { Alert } from "antd";
import { useAuth } from "config/auth/useAuth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Base from "views/Base";
import LoadingPage from "views/Base/components/LoadingPage";
import useStore from "../store";

const ACCESS_PERMISSION = "neoscan-pro.can-access";

export default function PrivateRoute() {
  const { loading } = useAuth();
  const navigate = useNavigate();
  const userData = useStore(state => state.userData);
  const canAccess = !!userData?.permissions?.includes(ACCESS_PERMISSION);

  useEffect(() => {
    if (userData && !canAccess) {
      navigate("/no-access", { replace: true });
    }
  }, [userData, canAccess]);

  if (loading) return <LoadingPage />;

  return <Alert.ErrorBoundary>{canAccess && <Base />}</Alert.ErrorBoundary>;
}
